var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTFlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9766_61785",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9766_61785)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.23242 3.71094L12.483 6.64159V12.4792L7.23242 9.5486V3.71094Z",
    fill: "#9872FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.418 6.64159L18.6687 3.71094V9.5486L13.418 12.4792V6.64159Z",
    fill: "#9872FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 0.332031L6.25074 3.26263V9.10019L1 6.16959V0.332031Z",
    fill: "#9872FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.23242 10.6602L12.483 13.5671V19.4282L7.23242 16.4977V10.6602Z",
    fill: "#9872FE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTFlogo);
export default __webpack_public_path__ + "static/media/TFlogo.76f241cd.svg";
export { ForwardRef as ReactComponent };